import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from './TrendStatCard.module.scss';

// Sparkline pattern forked from DashboardOverviewNew's TeamPerformance
// Sparkline (recharts <LineChart>, no axes/grid/tooltip) — that component is
// view-local to a different page, so this is a fresh, generalized version
// rather than a cross-view import.
export const TrendStatCardComponent = ({
  title,
  tooltip,
  value,
  tint,
  sparklineColor,
  sparklineData,
  deltaPct,
  deltaDirection = 'up',
}) => {
  const chartData = (sparklineData || []).map((v, i) => ({ i, v }));
  const isUp = deltaDirection === 'up';

  return (
    <div className={styles.card} style={{ background: `var(--${tint})` }}>
      <div className={styles.cardTitle}>
        <span>{title}</span>
        {tooltip && <InfoTooltip title={title} description={tooltip} />}
      </div>

      {chartData.length > 0 && (
        <div className={styles.sparklineWrapper}>
          <ResponsiveContainer width="100%" height={40}>
            <LineChart data={chartData}>
              <Line
                type="monotone"
                dataKey="v"
                stroke={`var(--${sparklineColor})`}
                strokeWidth={1.5}
                dot={false}
                isAnimationActive={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}

      <div className={styles.value}>{value}</div>

      {deltaPct != null && (
        <div className={styles.deltaRow}>
          {isUp ? (
            <FiArrowUp size={12} className={isUp ? styles.up : styles.down} />
          ) : (
            <FiArrowDown size={12} className={isUp ? styles.up : styles.down} />
          )}
          <span className={isUp ? styles.up : styles.down}>{deltaPct}%</span>
          <span className={styles.vsLabel}>vs yesterday</span>
        </div>
      )}
    </div>
  );
};

TrendStatCardComponent.displayName = 'TrendStatCard';
